import React from 'react'
import GoogleMapReact from 'google-map-react'

const Map = ({ libraries = [], children, mapType = 'hybrid', ...rest }) => {
  return (
    <GoogleMapReact
      {...rest}
      bootstrapURLKeys={{
        key: 'AIzaSyAMJ6G8DC3G8oulclyOW01GKGd8o_RBDhI',
        libraries,
        // Desde 3.65 Google quitó google.maps.drawing.DrawingManager y
        // rompía la carga del mapa base en Mapas. Clave es "version", no
        // "v": la lee @googlemaps/js-api-loader, usado por google-map-react.
        version: '3.64',
      }}
      options={{ styles: [], mapTypeId: mapType, gestureHandling: 'greedy' }}
    >
      {children}
    </GoogleMapReact>
  )
}

export default Map
